import { useSnackbarNotification } from '@jupiterone/jupiter-web-toolkit/src/components/notifications/SnackbarNotificationContext';
import { useEffect } from 'react';

const useAsyncEffect = (fn: () => Promise<any>, deps: any[]) => {
  const notifications = useSnackbarNotification();
  useEffect(() => {
    void (async () => {
      try {
        await fn();
      } catch (error) {
        notifications.error({ error, message: error.message });
      }
    })();
  }, deps);
};

export default useAsyncEffect;
